// @flow
export const HOUSE: "HOUSE" = "HOUSE";
export const APT: "APT" = "APT";
export const COMPANY: "COMPANY" = "COMPANY";
